import { categories, feed } from "@/mocks/chaqua";

interface CategoryFeedProps {
  activeCat: string;
  onPickCat: (key: string) => void;
}

export default function CategoryFeed({ activeCat, onPickCat }: CategoryFeedProps) {
  const list = activeCat === "all" ? feed : feed.filter((f) => f.cat === activeCat);

  return (
    <section id="feed" className="scroll-mt-20 bg-cream-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-6 flex flex-col justify-between gap-4 lg:flex-row lg:items-end">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-coral-500">By Category</span>
            <h2 className="mt-2 text-2xl font-black text-stone-900 md:text-3xl">分类速览，只看你感兴趣的</h2>
            <p className="mt-2 text-sm text-stone-500">按兴趣一键切换栏目，今日新鲜事随你挑选。</p>
          </div>
        </div>

        <div className="no-scrollbar mb-6 flex gap-2 overflow-x-auto pb-1" role="tablist" aria-label="栏目分类">
          {categories.map((c) => (
            <button
              key={c.key}
              role="tab"
              aria-selected={activeCat === c.key}
              onClick={() => onPickCat(c.key)}
              className={`flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition ${
                activeCat === c.key
                  ? "bg-stone-900 text-white"
                  : "bg-white text-stone-600 ring-1 ring-inset ring-cream-200 hover:text-coral-600 hover:ring-coral-200"
              }`}
            >
              <i className={c.icon} aria-hidden="true"></i>
              {c.name}
            </button>
          ))}
        </div>

        <div className="overflow-hidden rounded-2xl border border-cream-200 bg-white">
          <ul className="divide-y divide-cream-100">
            {list.map((f, idx) => (
              <li key={f.id}>
                <a
                  href="#big"
                  className="group flex items-center gap-4 px-4 py-3.5 transition hover:bg-cream-50 md:px-5"
                >
                  <span className="font-display-num w-6 shrink-0 text-center text-sm font-bold text-cream-300 transition group-hover:text-coral-500">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="hidden shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-coral-50 px-2.5 py-1 text-xs font-medium text-coral-600 sm:inline-flex">
                    <i className="ri-price-tag-3-line" aria-hidden="true"></i>
                    {categories.find((c) => c.key === f.cat)?.name}
                  </span>
                  <span className="min-w-0 flex-1 truncate text-sm font-medium text-stone-800 transition group-hover:text-coral-600 md:text-[15px]">
                    {f.title}
                  </span>
                  <span className="hidden shrink-0 whitespace-nowrap text-xs text-stone-400 sm:block">{f.time}</span>
                  <span className="shrink-0 whitespace-nowrap text-xs text-stone-400">{f.read} 阅读</span>
                  <i className="ri-arrow-right-line shrink-0 text-stone-300 transition group-hover:text-coral-500" aria-hidden="true"></i>
                </a>
              </li>
            ))}
            {list.length === 0 && (
              <li className="px-5 py-12 text-center text-sm text-stone-400">该栏目正在补货中，先去热榜看看吧。</li>
            )}
          </ul>
        </div>
      </div>
    </section>
  );
}